import Component from '../core/Component'

const meta = document.querySelector('meta[name="viewport"]')

export default class FormLogin extends Component {

    prepare() {
        meta.setAttribute('content', `${meta.getAttribute('content')}, maximum-scale=1, user-scalable=0`)
    }

}